
export function normalizeCustomer(payload) {
  if (!payload) return null;

  if (payload.status) {
    // new 
    return {
      status: payload.status,
      hasAcceptedTos: payload.has_accepted_terms_of_service,
      endorsements: payload.endorsements.map(x => ({ Name: x.name, Status: x.status })) || [],
      rejectionReasons: payload.rejection_reasons || [],
      requirementsDue: payload.requirement_due || [],
      capabilities: payload.capabilities || {},
      raw: payload,
    };
  }

  // old
  return {
    status: payload.Status,
    hasAcceptedTos: !!payload.HasAcceptedTermsOfService,
    endorsements: payload.Endorsements || [],
    rejectionReasons: payload.RejectionReasons || [],
    requirementsDue: payload.RequirementsDue || [],
    capabilities: payload.Capabilities || {},
    raw: payload,
  };
}

export function normalizeKyc(payload) {
  return {
    kycUrl: payload?.kyc || null,
    tosUrl: payload?.tos || null,
    raw: payload,
  };
}

export function normalizeTransfer(payload) {
  // GET /Transfer may return { transfer, metadata, archived }
  const transfer = payload?.transfer ? payload.transfer : payload;

  if (!transfer) return null;

  const id =
    transfer.Id ??
    transfer.id ??
    payload?.Id ??
    payload?.id ??
    transfer.LegalId ??
    transfer.legalId ??
    payload?.LegalId ??
    payload?.legalId ??
    null;
  const state =
    transfer.State ??
    transfer.state ??
    transfer.Status ??
    transfer.status ??
    payload?.State ??
    payload?.state ??
    payload?.Status ??
    payload?.status ??
    null;

  const deposit =
    transfer.SourceDepositInstructions ??
    transfer.sourceDepositInstructions ??
    transfer.DepositInstructions ??
    transfer.depositInstructions ??
    transfer.Deposit ??
    transfer.deposit ??
    transfer.Pix ??
    transfer.pix ??
    transfer.paymentInstructions ??
    transfer.PaymentInstructions ??
    payload?.deposit ??
    payload?.Deposit ??
    payload?.pix ??
    payload?.Pix ??
    payload?.paymentInstructions ??
    payload?.PaymentInstructions ??
    null;

  return {
    id,
    state,
    amount:
      transfer.Amount ??
      transfer.amount ??
      payload?.amount ??
      payload?.paymentInstructions?.Amount ??
      payload?.PaymentInstructions?.Amount ??
      null,
    onBehalfOf: transfer.OnBehalfOf ?? transfer.onBehalfOf ?? null,
    source: transfer.Source ?? transfer.source ?? null,
    destination: transfer.Destination ?? transfer.destination ?? null,
    deposit,
    receipt: transfer.Receipt ?? transfer.receipt ?? null,
    createdAt: transfer.CreatedAt ?? transfer.createdAt ?? null,
    updatedAt: transfer.UpdatedAt ?? transfer.updatedAt ?? null,
    metadata: payload?.metadata || transfer?.metadata || null,
    archived: payload?.archived ?? transfer?.archived ?? null,
    raw: payload,
  };
}